module.exports = __webpack_public_path__ + "img/moduleWu.9e458f76.png";